/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Play_Modes_TitleInputs */

const bn_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মোড`)
};

const de_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modi`)
};

const el_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λειτουργίες`)
};

const en_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modes`)
};

const es_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modos`)
};

const fr_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modes`)
};

const hi_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मोड`)
};

const hu_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módok`)
};

const id_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode`)
};

const it_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità`)
};

const ja_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モード`)
};

const ko_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모드`)
};

const nl_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modi`)
};

const pl_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tryby`)
};

const pt_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modos`)
};

const ru_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режимы`)
};

const sv_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägen`)
};

const tr_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modlar`)
};

const uk_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режими`)
};

const vi_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chế độ`)
};

const zh_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模式`)
};

const zh_hant_how_to_play_modes_title = /** @type {(inputs: How_To_Play_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模式`)
};

/**
* | output |
* | --- |
* | "Modes" |
*
* @param {How_To_Play_Modes_TitleInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const how_to_play_modes_title = /** @type {((inputs?: How_To_Play_Modes_TitleInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Play_Modes_TitleInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_how_to_play_modes_title(inputs)
	if (locale === "de") return de_how_to_play_modes_title(inputs)
	if (locale === "el") return el_how_to_play_modes_title(inputs)
	if (locale === "en") return en_how_to_play_modes_title(inputs)
	if (locale === "es") return es_how_to_play_modes_title(inputs)
	if (locale === "fr") return fr_how_to_play_modes_title(inputs)
	if (locale === "hi") return hi_how_to_play_modes_title(inputs)
	if (locale === "hu") return hu_how_to_play_modes_title(inputs)
	if (locale === "id") return id_how_to_play_modes_title(inputs)
	if (locale === "it") return it_how_to_play_modes_title(inputs)
	if (locale === "ja") return ja_how_to_play_modes_title(inputs)
	if (locale === "ko") return ko_how_to_play_modes_title(inputs)
	if (locale === "nl") return nl_how_to_play_modes_title(inputs)
	if (locale === "pl") return pl_how_to_play_modes_title(inputs)
	if (locale === "pt") return pt_how_to_play_modes_title(inputs)
	if (locale === "ru") return ru_how_to_play_modes_title(inputs)
	if (locale === "sv") return sv_how_to_play_modes_title(inputs)
	if (locale === "tr") return tr_how_to_play_modes_title(inputs)
	if (locale === "uk") return uk_how_to_play_modes_title(inputs)
	if (locale === "vi") return vi_how_to_play_modes_title(inputs)
	if (locale === "zh") return zh_how_to_play_modes_title(inputs)
	return zh_hant_how_to_play_modes_title(inputs)
});